<template>
  <Modal :modal-style="{ width: '500px' }">
    <img
      class="full-height full-width"
      :src="imageUrl"
    />
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "ImageModal",
  components: {
    Modal,
  },
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
  },
};
</script>
